import { render } from "./AccountCreateCard.vue?vue&type=template&id=c94b2f6c&scoped=true"
import script from "./AccountCreateCard.vue?vue&type=script&lang=js"
export * from "./AccountCreateCard.vue?vue&type=script&lang=js"

import "./AccountCreateCard.vue?vue&type=style&index=0&id=c94b2f6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94b2f6c"]])

export default __exports__